export default function checkStateDate(pDate) {
    if(!pDate) return pDate;
    let today = new Date();
    let date = new Date(pDate.replace(/-/g, "/"));
    //console.log(date,today, pDate, (today.getTime() < date.getTime()));
    return today.getTime() < date.getTime();
  }
  